import { render } from "./consultationDetailed.vue?vue&type=template&id=c2508c4e&scoped=true"
import script from "./consultationDetailed.vue?vue&type=script&lang=js"
export * from "./consultationDetailed.vue?vue&type=script&lang=js"

import "./consultationDetailed.vue?vue&type=style&index=0&id=c2508c4e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c2508c4e"

export default script